import React from 'react';
import { motion } from 'framer-motion';

function ContactInfo() {
  return (
    <motion.div 
      className='d-flex flex-column align-items-center'
      initial={{ opacity: 0, x: -300 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
    >
        <h2 className='fs-1 mb-3 text-uppercase fw-bold'>Onde Encontrar-nos</h2>
        <p className='mb-5'>Rua Cdt Hoji Ya Henda, Lubango, Angola</p>
        <h3 className='text-capitalize'>Horário de Operações</h3>
        <p className="m-0">Seg - Sex: 07:00 - 23:00</p>
        <p>Sab - Dom: 07:00 - 23:00</p>
    </motion.div>
  )
}

export default ContactInfo;